import * as React from 'react';

import { MetricBaseCard, MetricBaseCardProps } from './MetricBaseCard';
import { MetricCardProps } from './MetricCardProps';

export const SmallMetricCard = (props: MetricCardProps): JSX.Element => {
  const p: MetricBaseCardProps = {
    ...props,
    dotSize: 3,
    banStyle: {
      fontSize: '32px',
      lineHeight: '32px',
    },
    labelStyle: {
      fontSize: '10px',
      marginTop: '8px',
      paddingBottom: '8px',
      lineHeight: '10px',
    },
    timeSeriesContainerStyle: {
      height: '28px',
      marginTop: '0px',
    },
    timeSeriesRightMargin: 32,
  };
  return <MetricBaseCard {...p} />;
};
